// eslint-disable-next-line max-len
import { CELLPHONE_RECOVERY_OPERATIONS } from '../../../../../static-source/constants/cellphone_recovery_operations';
import CellphoneRecoveryStepPhone from './step_phone';
import CellphoneRecoveryStepConfirmSms from '../../../../../static-source/components/cellphone_recovery_operations/step_confirm_sms';

import {
    CELLPHONE_RECOVERY_STORE_NAMESPACE,
    MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS,
} from '../store';

export const RESET_TYPES = {
    sms: Symbol('sms'),
};

const STEP_COMPONENT_PREFIX = 'cellphone-recovery-step-';

const STEPS = {
    phone: `${STEP_COMPONENT_PREFIX}phone`,
    confirm_sms: `${STEP_COMPONENT_PREFIX}confirm-sms`,
};

export default {
    name: 'cellphone-recovery',
    template: '#js-tmpl-cellphone-recovery',
    components: {
        CellphoneRecoveryStepPhone,
        CellphoneRecoveryStepConfirmSms,
    },
    data() {
        return {
            STEPS,
            processing: false,
        };
    },
    mounted() {
        this.$store.commit(
            `${CELLPHONE_RECOVERY_STORE_NAMESPACE}/${MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS}`
        );
    },
    computed: {
        store() {
            return this.$store.state[CELLPHONE_RECOVERY_STORE_NAMESPACE];
        },
        storeUpdateMutation() {
            return `${CELLPHONE_RECOVERY_STORE_NAMESPACE}/${MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS}`;
        },
        currentStepComponent() {
            const {
                showSmsDialog,
                showPhoneDialog,
                phoneConfirmed
            } = this.store;

            const STEPS_STATE_MACHINE = [
                {
                    step: STEPS.confirm_sms,
                    active: showSmsDialog || phoneConfirmed,
                },
                {
                    step: STEPS.phone,
                    active: showPhoneDialog,
                },
            ];

            const nextStep = STEPS_STATE_MACHINE.find(step => step.active);
            return nextStep ? nextStep.step : STEPS.phone;
        },
        stepComponentProps() {
            const operation = CELLPHONE_RECOVERY_OPERATIONS.cellphoneRecovery;

            return {
                operation,
                cancelOperationUrl: this.store.urls.passwordResetIndexUrl
            };
        }
    },
    methods: {
        updateComponentData(data = {}) {
            try {
                this.$store.commit(this.storeUpdateMutation, data);
            } catch (error) {
                console.error('Error updating component data:', error);
            }
        },
    },
};
